/* Return window is 14 days. The "30-day" wording lived in several places
   (trust line, FAQ, script-rendered copy, cart drawer), so this rewrites any
   "30-day" / "30 days" text node on the storefront to 14, and keeps doing it
   for content rendered later. Only matches 30 followed by day/days. */
(function(){
var RX=/\b30(\s*-\s*|\s+)(day|days|Day|Days|DAY|DAYS)\b/g;
function fix(root){
if(!root)return;
var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null);
var n;
while((n=w.nextNode())){
var p=n.parentNode;
if(p&&(p.tagName==='SCRIPT'||p.tagName==='STYLE'))continue;
var t=n.nodeValue;
if(t&&t.indexOf('30')>-1&&RX.test(t)){RX.lastIndex=0;n.nodeValue=t.replace(RX,'14$1$2');}
RX.lastIndex=0;
}
}
function run(){fix(document.body);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
if(window.MutationObserver){
var t=null;
new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,120);}).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
}
})();
